import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import appAPI from '../../api/api'
import { Competence } from '../../api/model/competence'

export type CompetenciesState = {
  competencies: Competence[]
  loading: boolean
  loaded: boolean
}

const initialCompetenciesState: CompetenciesState = {
  competencies: [],
  loading: false,
  loaded: false,
}

const fetchCompetencies = createAsyncThunk('/fetchCompetencies', async () => {
  return await appAPI.competences.getCompetences<Competence[]>()
})

const competenciesSlice = createSlice({
  name: 'competencies',
  initialState: initialCompetenciesState,
  reducers: {
    clearCompetencies: (state: CompetenciesState) => {
      state.competencies = initialCompetenciesState.competencies
      state.loading = initialCompetenciesState.loading
      state.loaded = initialCompetenciesState.loaded
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompetencies.pending, (state) => {
        state.loading = true
        state.loaded = false
      })
      .addCase(fetchCompetencies.fulfilled, (state: CompetenciesState, { payload }) => {
        state.competencies = payload.data
        state.loading = false
        state.loaded = true
      })
      .addCase(fetchCompetencies.rejected, (state: CompetenciesState) => {
        state.loading = false
        state.loaded = true
      })
  },
})

export default competenciesSlice.reducer

export const competenciesSliceActions = {
  ...competenciesSlice.actions,
  fetchCompetencies,
}
